/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { FetchReviewFilterPayload, GetReviewResponse, ReviewState } from '../../../interface';

export const initialState:ReviewState = {
  loading: false,
  reviews: [],
  total: 0,
};

export const reviewSlice = createSlice({
  name: 'feature/review',
  initialState,
  reducers: {
    getReviews(state: ReviewState, action: PayloadAction<FetchReviewFilterPayload>) {
      state.loading = true;
    },
    getReviewsSucceeded(state: ReviewState, _action: PayloadAction<GetReviewResponse>) {
      const { result, total } = _action.payload;
      state.loading = false;
      state.reviews = result;
      state.total = total;
    },
    getReviewsFailed(state: ReviewState) {
      state.loading = false;
    },
  },
});

export const { actions: reviewAction } = reviewSlice;
